// Copyright (c) Bentley Systems
import { Style } from "../../DataModels/style";
import { EfActionModel } from "./ef-action-model";
import { EfControlStructure } from "./ef-control-structure";
import { EfData } from "./ef-data";
import { EfMatchCode } from "./ef-match-code";
import { EfRecord } from "./ef-record";

export class EformStructureModel {
  public nodeId: number | undefined;
  public efRecords: EfRecord[] = [];
  public efControlStructures: EfControlStructure[] = [];
  public efActions: EfActionModel[] = [];
  public efMatchCodes: EfMatchCode[] = [];
  public styles: Style[] = [];
  public efDatas: EfData[] = [];

  constructor(initializer?: any) {
    if (!initializer) {
      return;
    }
    if (initializer.nodeId) {
      this.nodeId = initializer.nodeId;
    }
    if (initializer.efRecords) {
      this.efRecords = initializer.efRecords;

      this.efRecords.forEach((record) => {
        if (record.efFields.length > 0) {
          record.efFields = record.efFields.sort(
            (a, b) => (a.rank as number) - (b.rank as number),
          );
        }
      });
    }
    if (initializer.efControlStructures) {
      this.efControlStructures = initializer.efControlStructures;
    }
    if (initializer.efActions) {
      this.efActions = initializer.efActions;
    }
    if (initializer.efMatchCodes) {
      this.efMatchCodes = initializer.efMatchCodes;
    }
    if (initializer.styles) {
      this.styles = initializer.styles;
    }
    if (initializer.efDatas) {
      this.efDatas = initializer.efDatas;
    }
  }
}
